import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import AccessForm from "../../../../components/reports/access-form/access-form.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputForm
                            label="ID"
                            value={filters.garrisonId}
                            onChange={({target}) => setFilters(prev => ({ ...prev, garrisonId: target.value }))}
                            instanceId="garrisonId"
                            id="garrisonId"
                            classNameWrapper={"w-full"}
                            autocomplete={'off'}
                        />
                    </div>

                    <div>
                        <SelectComponent
                            label='Ação'
                            isMulti={false}
                            options={[
                                {label: "Todos", value: 'all'},
                                {label: "Cadastro", value: 'create'},
                                {label: "Alteração", value: 'update'},
                                {label: "Visualização", value: 'view'}
                            ]}
                            value={filters.action}
                            onChange={(value) => setFilters(prev => ({...prev, action: value}))}
                            instanceId="action"
                            classNameWrapper={"w-full"}
                            isClearable={false}
                        />
                    </div>

                    <AccessForm filters={filters} setFilters={setFilters}/>

                </form>
            </div>
        </>
    );
};

export default Filters;